import React from "react";
import declension from "ati-core-utils/declension";
import interpolate from "ati-core-utils/interpolate";
import MoneyLogo from "../../img/money-logo.svg";
import MoneyLogo2 from "../../img/money-logo-2.svg";
import NotesLogo from "../../img/notes-logo.svg";
import TimerLogo from "../../img/timer-logo.svg";
import CalendarLogo from "../../img/calendar-logo.svg";
import FuelCalendarLogo from "../../img/fuel-calendar.svg";
import i18nStrings from "../../strings/stings";
import ShieldLogo from "../../img/shield-logo.svg";
import FuelShieldLogo from "../../img/fuel-shield.svg";
import {
  TermsBlockStyle,
  TermsItemStyle,
  TermsImage,
  TermsTitle,
} from "./TermsBlock.styles";
import { roles } from "../../const";
import { limitSeparate } from "../../utils/limitSeparate";

interface TermsBlock {
  role: number,
  limit: number
}

const TermsBlock = ({ role, limit }: TermsBlock) => {
  const strings = i18nStrings;
  const money = `${limitSeparate(limit, true)}\u00a0${declension(limit, strings.rubl)}`;

  const getTermItemsInfo = () => {
    if (role === roles.fuel) {
      return [
        {
          iconSrc: MoneyLogo2,
          title: interpolate(strings.fuelFirstItemTitle, { money }),
          iconWith: 140,
          iconWithMobile: 100,
        },
        {
          iconSrc: FuelCalendarLogo,
          title: strings.fuelSecondItemTitle,
        },
        {
          iconSrc: FuelShieldLogo,
          title: strings.fuelThirdItemTitle,
        },
      ];
    }
    if (role === roles.carrier) {
      return [
        {
          iconSrc: MoneyLogo,
          title: interpolate(strings.limitForActivity, { money }),
        },
        {
          iconSrc: NotesLogo,
          title: strings.documents,
        },
        {
          iconSrc: TimerLogo,
          title: strings.request,
        },
      ];
    }
    return [
      {
        iconSrc: MoneyLogo,
        title: interpolate(strings.limitForActivity, { money }),
      },
      {
        iconSrc: CalendarLogo,
        title: strings.paymentWhen,
      },
      {
        iconSrc: ShieldLogo,
        title: strings.withoutHiddenComission,
      },
    ];
  };

  const renderTermItems = () => {
    const termItems = getTermItemsInfo();

    return termItems.map((item) => (
      <TermsItemStyle key={item.title}>
        <TermsImage
          alt=""
          height={item.iconHeight}
          heightMobile={item.heightMobile}
          src={item.iconSrc}
          width={item.iconWith}
          widthMobile={item.iconWithMobile}
        />
        <TermsTitle>{item.title}</TermsTitle>
      </TermsItemStyle>
      ));
  };

  return (
    <TermsBlockStyle>
      {renderTermItems()}
    </TermsBlockStyle>
  );
};

export default TermsBlock;
